import { Guid } from 'guid-typescript'

import { BaseButton } from '../Buttons/types'

export default class RowOfButtons {
  private _buttons: Array<BaseButton>

  guid = Guid.create().toString()

  get buttons(): Array<BaseButton> {
    return this._buttons
  }

  set buttons(buttons) {
    this._buttons = buttons
  }

  constructor(row: Array<BaseButton>) {
    this._buttons = row
  }

  getButton(guid: string): BaseButton | undefined {
    return this._buttons.find((b) => b.guid === guid)
  }

  addButton(button: BaseButton): void {
    this._buttons.push(button)
  }

  removeButton(button: BaseButton): void {
    this._buttons = this._buttons.filter(b =>b.guid !== button.guid)
  }

  getModel(): Array<BaseButton> {
    return this._buttons
  }
}
